import {
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  InputAdornment,
  Paper,
  TextField,
  Typography,
  Button,
  Icon,
  Popover,
  List,
  ListItem,
  Divider
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Search } from "@material-ui/icons";
import GridItem from "components/Grid/GridItem.jsx";
import React from "react";

class BaseTablePageContent extends React.Component {
  state = {
    filterEl: null
  };

  handlePopoverClose = name => {
    this.setState({
      [name]: null
    });
  };

  handlePopoverOpen = (event, name) => {
    this.setState({
      [name]: event.currentTarget
    });
  };

  render() {
    return (
      <div className='contentWithStepper'>
     
          <Card>
          <CardHeader
            title={this.props.title}
            style={{ textAlign: 'center' }}
          />
            <CardContent>

              <TextField
                id="input-with-icon-textfield"
                fullWidth
                style={{ marginBottom: "3vh" }}
                placeholder="Search by Name, Surname, or Email"
                onChange={this.props.handleSearch}
                label="Search"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  )
                }}
              />

              <Paper style={{ overflowX: "auto" }}>{this.props.children}</Paper>
            </CardContent>
          </Card>
       
      </div>
    );
  }
}

export default BaseTablePageContent;



// WEBPACK FOOTER //
// ./src/views/Clients/components/BaseTablePageContent.jsx